import { render, staticRenderFns } from "./Badge8.vue?vue&type=template&id=fcfb3a52&scoped=true"
import script from "./Badge8.vue?vue&type=script&lang=js"
export * from "./Badge8.vue?vue&type=script&lang=js"
import style0 from "./Badge8.vue?vue&type=style&index=0&id=fcfb3a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfb3a52",
  null
  
)

export default component.exports